const robot = {
  namespaced: true,
  state: {
    // 存储选中的用户ID列表
    selectedUserIds: [],
    // 存储选中的标签ID列表
    selectedTagIds: [],
    // 存储选中的群组ID列表
    selectedRoomIds: []
  },
  mutations: {
    // 设置选中的用户ID列表
    SET_SELECTED_USER_IDS: (state, userIds) => {
      state.selectedUserIds = userIds
    },
    // 清空选中的用户ID列表
    CLEAR_SELECTED_USER_IDS: (state) => {
      state.selectedUserIds = []
    },
    // 设置选中的标签ID列表
    SET_SELECTED_TAG_IDS: (state, tagIds) => {
      state.selectedTagIds = tagIds
    },
    // 清空选中的标签ID列表
    CLEAR_SELECTED_TAG_IDS: (state) => {
      state.selectedTagIds = []
    },
    // 设置选中的群组ID列表
    SET_SELECTED_ROOM_IDS: (state, roomIds) => {
      state.selectedRoomIds = roomIds
    },
    // 清空选中的群组ID列表
    CLEAR_SELECTED_ROOM_IDS: (state) => {
      state.selectedRoomIds = []
    }
  },
  actions: {
    // 设置选中的用户ID
    setSelectedUserIds({ commit }, userIds) {
      commit('SET_SELECTED_USER_IDS', userIds)
    },
    // 清空选中的用户ID
    clearSelectedUserIds({ commit }) {
      commit('CLEAR_SELECTED_USER_IDS')
    },
    // 设置选中的标签ID
    setSelectedTagIds({ commit }, tagIds) {
      commit('SET_SELECTED_TAG_IDS', tagIds)
    },
    // 清空选中的标签ID
    clearSelectedTagIds({ commit }) {
      commit('CLEAR_SELECTED_TAG_IDS')
    },
    // 设置选中的群组ID
    setSelectedRoomIds({ commit }, roomIds) {
      commit('SET_SELECTED_ROOM_IDS', roomIds)
    },
    // 清空选中的群组ID
    clearSelectedRoomIds({ commit }) {
      commit('CLEAR_SELECTED_ROOM_IDS')
    }
  },
  getters: {
    // 在模块内部定义getter，与命名空间保持一致
    selectedUserIds: (state) => state.selectedUserIds,
    selectedTagIds: (state) => state.selectedTagIds,
    selectedRoomIds: (state) => state.selectedRoomIds
  }
}

export default robot